<template>
  <div ref="wsRef" id="ws-walkscore-tile"></div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import config from '@/config';

  export default {
    name: 'HMTWalkScoreFrame',
    props: {
      address: {
        default: '',
        type: String
      },
      wsFormat: {
        default: 'wide',
        type: String
      },
      wsWidth: {
        default: '100%',
        type: String
      },
      wsHeight: {
        default: 525,
        type: Number
      },
      wsBackgroundColor: {
        default: '#fff',
        type: String
      }
    },
    computed: {
      ...mapGetters('tour', ['getWalkScoreAddress'])
    },
    methods: {
      init () {
        window.ws_address = this.address ? this.address : this.getWalkScoreAddress;
        window.ws_wsid = config.WALK_SCORE_ID;
        window.ws_format = this.wsFormat;
        window.ws_width = this.wsWidth;
        window.ws_height = this.wsHeight;
        window.ws_background_color = this.wsBackgroundColor;

        const script = document.createElement('script');
        script.async = true;
        script.src = config.WALK_SCORE_URL;
        this.$refs.wsRef.appendChild(script);
      }
    },
    mounted () {
      this.init();
    }
  };
</script>

<style lang="scss">
  #ws-walkscore-tile {
    iframe {
      height: 100%;
    }
  }
</style>
